import { APIURL } from '../services/axiosServices/ApiEndPoints';
import SwalServices from '../services/swalServices/SwalServices';
import { decryptionAPI } from './Encryption';
import { removeAllCookies } from './cookies/CookieHandler';
import { Value3, Value4 } from './AppSetting';

const axios = require('axios');
// axios.defaults.withCredentials = true;
export const axiosInstance = axios.create({
    baseURL: APIURL
})
axiosInstance.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
)
const isHandlerEnabled = (config = {}) => {
    return config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled ?
        false : true
}
// await axiosInstance.get('/v2/api-endpoint', { handlerEnabled: false }) --if we want to exclude any api from using interceptor use this
const requestHandler = (request) => {
    if (isHandlerEnabled(request)) {
    }
    return request
}
axiosInstance.interceptors.request.use(
    request => requestHandler(request)
)

// Helper function to clear all auth data and redirect to login
const clearAuthAndRedirect = () => {
    // Clear all cookies
    removeAllCookies();

    // Clear localStorage
    localStorage.removeItem(Value3);
    localStorage.removeItem(Value4);
    localStorage.removeItem('Token101');
    localStorage.removeItem('AuthUserWeb101');
    localStorage.clear();

    // Redirect to login page
    window.location.href = "/";
};

const errorHandler = (error) => {
    const responseData = error.response?.data;

    // Only redirect to login if the response explicitly contains logout/redirectToLogin flags
    // This prevents login page errors (wrong password) from triggering redirect
    if (responseData?.logout === true || responseData?.redirectToLogin === true) {
        clearAuthAndRedirect();
        return;
    }

    // For all other errors (including login failures), return the response data
    return responseData;
}

const successHandler = (response) => {
    if (isHandlerEnabled(response.config)) {
        response = decryptionAPI(response.data);
    }
    return response
}

export const axiosInstanceWithoutEnrypt = axios.create({
    baseURL: APIURL
})
